import type { ComponentProps } from 'react';
// components
import HubertCombobox from 'components/HubertUI/HubertCombobox';
// hooks
import { useGetAllAdminsQuery } from 'rtk/query/apis/admins';
//types
import Loading from 'components/common/Loading';
import IsAxiosError from 'components/common/IsAxiosError';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
}

const AdminCombobox = ({ isMulti = false, onValueChange, value, disabled = false, ...props }: Props) => {
  const { data, isLoading, isFetching, isError, error } = useGetAllAdminsQuery();

  if (isLoading || isFetching) {
    return <Loading label="languages" />;
  }

  if (isError) {
    return <IsAxiosError error={error} />;
  }

  if (!data) {
    return null;
  }

  return (
    <div {...props}>
      <HubertCombobox
        itemName="admin"
        isMulti={isMulti}
        items={data.admins.map((x) => {
          return {
            ...x,
            label: `${x.first_name} ${x.last_name}`,
            value: x._id,
          };
        })}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default AdminCombobox;
